import { DATA_TABLE_ITEMS_PER_PAGE } from '../constants'

export type QueryParams = {
  page: number
  limit?: number
  sort?: {
    column: string
    order: 'asc' | 'desc'
  }
} & {
  [key: string]: unknown
}

export const getQueryParams = ({
  limit = DATA_TABLE_ITEMS_PER_PAGE,
  page,
  sort,
  ...rest
}: QueryParams): string => {
  return new URLSearchParams({
    limit: String(limit),
    page: String(page),
    ...(sort && {
      orderColumn: sort.column,
      orderOrientation: sort.order,
    }),
    ...rest,
  }).toString()
}
